import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../reducer";
import { Table, TableOrNotFound } from "../types/table";

// Passthrough selectors for object/map state slices
export const selectTableRunResponses = (state: RootState) =>
  state.tables.tableRunResponses;

export const selectTableSpecs = (state: RootState) => state.tables.tableSpecs;

export const selectNotFoundTables = (state: RootState) =>
  state.ui.notFoundTables;

export const selectTableLogsMap = (state: RootState) =>
  state.tables.tableLogsMap;

export const selectTables = (state: RootState) => state.tables.tables;

export const selectTableRunHistoryMap = (state: RootState) =>
  state.tables.tableRunHistoryMap;

export const selectTableRunControlMap = (state: RootState) =>
  state.tables.tableRunControlMap;

export const selectTableLoadingMap = (state: RootState) =>
  state.tables.tableLoadingMap;

// Module-scoped memoized selector: maps tables → { [fileId]: Table }
export const selectFileIdToTable = createSelector(
  (state: RootState) => state.tables.tables,
  (tables): Record<string, Table> =>
    Object.fromEntries(
      Object.values(tables).map((table) => [table["file-id"], table])
    )
);

// Factory for parameterized selector: resolves inputFileIds → TableOrNotFound[]
export const makeSelectInputTables = (inputFileIds: string[]) =>
  createSelector(selectFileIdToTable, (fileIdToTable): TableOrNotFound[] =>
    inputFileIds.map(
      (fileId) =>
        fileIdToTable?.[fileId] ?? { "not-found": true, "file-id": fileId }
    )
  );
